module.exports = __webpack_public_path__ + "static/img/iphone.9c787b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iphone.png
// module id = 7Rkl
// module chunks = 0